<template>
    <section class="is-large">
        <div class="container">
            <div class="box">
                <h3 class="title is-3 has-text-centered">Filter Options</h3>
                <div class="field is-grouped is-justify-content-center">
                    <button
class="button is-primary :focus"
@click="getJobs()">All Jobs</button>
                    <button
class="button is-info"
@click="filterJobs(null, true, false)">Show Only Jobs With Emails</button>
                    <button
class="button is-success is-outlined :focus"
@click="filterJobs(true, null, false)">Relevant Jobs</button>
                    <button
class="button is-danger is-outlined :focus"
@click="filterJobs(false, null, false)">Irrelevant Jobs</button>
                    <button
class="button is-info is-outlined :focus"
@click="filterJobs(null, null, true)">Queued Jobs</button>
                </div>
            </div>
            <div v-if="error" class="notification is-danger is-light">
                <button class="delete" @click="error = null"></button>
                Failed to load jobs. Please try again.
            </div>
            <div v-if="loading && jobs.length === 0" class="has-text-centered p-6 loading-state">
                <span class="button is-loading is-large is-ghost"></span>
                <p class="mt-2">Loading your jobs...</p>
            </div>
            <div v-else class="columns">
                <div
class="column is-one-third job-sidebar">
                    <div
v-for="job in jobs"
:key="job.id"
class="cell m-2 p-2">
                        <InterestBadge
:key="job.relevant"
:job="job"
@load_job_description="loadJobDescription"></InterestBadge>
                        <CardItem
                            :key="job.relevant"
                            :job="job.ranked_job_id"
                            :job_score="job.job_score"
                            :job-match-i-d="job.id"
                            :is-relevant="job.relevant"
                            @load_job_description="loadJobDescription">
                        </CardItem>
                    </div>
                </div>
                <div class="column">
                    <component
                        :is="dynamicComponent"
                        v-if="dynamicComponent"
                        :job="selectedJob"
                        :job-match-i-d="selectedJobMatchId"
                        :is-relevant="isRelevant"
                        @select_job_to_match="selectJobToMatch"
                    ></component>
                </div>
            </div>
        </div>
    </section>
    <Pagination
:links="links"
:content="content"
@get-jobs="getJobs"></Pagination>
</template>
<script setup lang="ts">
import { ref, onMounted, nextTick, shallowRef, type Component } from "vue"
import { assign_job_to_user } from "../utils"
import { useJobList } from "../composables/useJobList"
import { API_BASE } from "../config"
import CardItem from "./JobList/CardItem.vue"
import Pagination from "./Pagination.vue"
import DescriptionItem from "./JobList/Description.vue"
import InterestBadge from "./JobList/InterestBadge.vue"

const { jobs, links, content, loading, error, getJobs } = useJobList({
  baseUrl: `${API_BASE}/job_matches`,
  routeName: "user-job-list",
  auth: true,
})

const selectedJob = ref<any>(null)
const selectedJobMatchId = ref<string | null>(null)
const isRelevant = ref<boolean | null>(null)
const dynamicComponent = shallowRef<Component | null>(null)

function loadJobDescription(job: any, matchId: string, relevant: boolean | null) {
  selectedJob.value = job
  selectedJobMatchId.value = matchId
  isRelevant.value = relevant
  dynamicComponent.value = DescriptionItem
}

function filterJobs(relevant: boolean | null = null, hasEmail: boolean | null = null, unprocessedOnly = false) {
  const params: Record<string, any> = {}
  if (relevant !== null) params.relevant = relevant
  if (hasEmail !== null) params.has_email = hasEmail
  if (unprocessedOnly) params.relevant__isnull = true
  getJobs(null, params)
}

async function selectJobToMatch(job: any, matchId: string, relevant: boolean | null) {
  job.relevant = relevant === true ? false : relevant === false ? null : true
  job.job_id = job.id
  job.id = matchId
  const data = await assign_job_to_user(job, "patch")
  isRelevant.value = data.relevant
  await nextTick()
}

onMounted(() => getJobs())
</script>

<style scoped>
.job-sidebar {
  max-height: 75rem;
  overflow: auto;
  scroll-behavior: smooth;
}
</style>
